import { TableBody, Table, Typography, styled, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useContainer } from 'unstated-next';
import copy from 'copy-to-clipboard';
import { useState, useRef } from 'react';
import { getUrls } from '../../../utils/url';
import { NetworkingTableRow } from '../components/Networking/NetworkingTableRow';
import AdminSettingsContainer from '../AdminSettingsContainer';

const Title = styled(Typography)`
    margin-bottom: 16px;
` as typeof Typography;

const Instructions = styled(Typography)`
    font-weight: 500;
` as typeof Typography;

const CopyAllButton = styled(Button)`
    margin-bottom: 16px;
` as typeof Button;

const StyledTable = styled(Table)`
    width: auto;
    table-layout: auto;
` as typeof Table;

const sortClassUrls = (a: string, b: string) => {
    if (a.includes('https://main') || a.includes('wss://')) {
        return -1;
    }

    if (b.includes('https://main') || b.includes('wss://')) {
        return 1;
    }

    if (a < b) {
        return -1;
    }

    if (a > b) {
        return 1;
    }

    return 0;
};

const teamsUrls = [
    'https://*.events.data.microsoft.com',
    'https://ecs.communication.microsoft.com',
    'https://*.prod.registrar.skype.com',
    'https://api.flightproxy.skype.com',
    'https://*.trouter.communication.microsoft.com',
    'https://auth.relay.communication.microsoft.com',
    'https://*.trouter.teams.microsoft.com',
    'wss://*.trouter.teams.microsoft.com',
    'https://*.ingest.sentry.io'
];

const Networking = () => {
    const { t } = useTranslation('admin_settings');
    const { t: tCommon } = useTranslation('common');

    const { school } = useContainer(AdminSettingsContainer);

    const isTeams = school?.isTeams;

    const urls = [...new Set(Object.values(getUrls()))].sort(sortClassUrls);

    if (isTeams) {
        urls.push(...teamsUrls);
    }

    const [hasCopied, setHasCopied] = useState(false);
    const timeoutRef = useRef<number>();

    const buttonText = hasCopied ? tCommon('copied') : tCommon('copy-all');

    const onCopyAll = () => {
        window.clearTimeout(timeoutRef.current);

        const allUrls = urls.join('\n');
        copy(allUrls);

        setHasCopied(true);

        timeoutRef.current = window.setTimeout(() => {
            setHasCopied(false);
        }, 2000);
    };

    return (
        <Box>
            <Title variant="h1">{t('navigationTabs.networking')}</Title>

            <Instructions>{t('networking.instructions')}</Instructions>

            <CopyAllButton onClick={onCopyAll} variant="outlined" size="small">
                {buttonText}
            </CopyAllButton>

            <StyledTable size="small">
                <TableBody>
                    {urls.map((url, i) => (
                        <NetworkingTableRow key={`${url}-${i}`} url={url} />
                    ))}
                </TableBody>
            </StyledTable>
        </Box>
    );
};

export default Networking;
